// campaign-list-date.ts — the date label shown on each row/card of the
// scheduled-message + campaign management list (management-list.tsx).
//
// FE#254: a regression dropped the TIME from this label — the redesign list
// rendered date-only (`{ month, day }`), so with many rows you could no longer
// tell two same-day sends apart. The prior list showed date + time; this
// restores it. Kept as a tiny pure helper (like campaign-list-sort.ts /
// campaign-list-view.ts) so it is unit-testable without pulling in the heavy
// React module.

/**
 * Format a scheduled/started timestamp for the management-list row label.
 * Restores the PRE-REDESIGN date+time format (FE#254): the campaign list that
 * the redesign (commit 3c70238f8) replaced rendered this via
 * `formatISOCampaignCreationTime` in bt-bulk-dashboard/campaign-card.tsx —
 * `toLocaleDateString('en-GB')` + `toLocaleTimeString('en-GB', {hour12:false})`
 * → e.g. "18/08/2026, 14:30:00" (DD/MM/YYYY 24h). Matching it exactly rather
 * than guessing a new format. Returns '' for a missing or unparseable value.
 */
export function formatStartedRaw(raw?: string | Date): string {
  if (!raw) return '';
  const d = new Date(raw);
  if (Number.isNaN(d.getTime())) return '';
  const date = d.toLocaleDateString('en-GB');
  const time = d.toLocaleTimeString('en-GB', { hour12: false });
  return `${date}, ${time}`;
}
